<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @cancel-replenishment="cancelReplenishment"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <CancelReplenishment
      :visible.sync="cancelReplenishmentOpts.visible"
      :amzReplenishmentCode="cancelReplenishmentOpts.amzReplenishmentCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import CancelReplenishment from '../cancel-replenishment'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, CancelReplenishment },
  data() {
    return {
      usePage: true,
      cancelReplenishmentOpts: { visible: false, amzReplenishmentCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-operateReplyConfirm-detail',
        params: { ...params, pageType },
        query,
      })
    },
    cancelReplenishment({ amzReplenishmentCode }) {
      this.cancelReplenishmentOpts = { visible: true, amzReplenishmentCode }
    },
  },
}
</script>
